import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";
import { modalAnatomy } from "@chakra-ui/anatomy";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = definePartsStyle((props) => ({
  header: defineStyle({
    fontFamily: "var(--ibm-plex-mono)",
    fontWeight: 600,
    fontSize: "12px",
    color: "blackAlpha.600",
    textTransform: "uppercase",
  }),
  // Chakra gives the body `flex: 1; overflow: auto` but leaves `min-height` at
  // its `auto` default, so as a flex item it refuses to shrink below its
  // content. With enough content the body outgrows the dialog's maxH instead
  // of scrolling inside it. Tall viewports hide this; short ones (mobile) clip
  // the overflow. `minH: 0` lets it shrink so `overflow: auto` can engage.
  body: defineStyle({
    minH: 0,
    // iOS chains a touch-scroll to the ancestor once the body hits either end.
    // The dialog container is `position: fixed; overflow: hidden`, so that
    // chained gesture gets swallowed and the drag stops moving the list.
    // `contain` keeps the gesture on the body. Desktop wheel scrolling is
    // unaffected, which is why this only ever reproduced on a real device.
    overscrollBehavior: "contain",
    // Required by older iOS Safari for a nested scroll container to accept
    // touch momentum at all; a no-op on browsers that dropped the prefix.
    WebkitOverflowScrolling: "touch",
  }),
  // Only cap the dialog when it scrolls internally; `outside` modals are
  // meant to grow past the viewport and let the container scroll. dvh rather
  // than Chakra's `%` so mobile browsers account for the collapsing address bar.
  dialog:
    props.scrollBehavior === "inside"
      ? defineStyle({ maxH: "calc(100dvh - 7.5rem)" })
      : defineStyle({}),
}));

export const Modal = defineMultiStyleConfig({
  baseStyle,
});
